import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { Button, PrimaryButton } from "../../../ui/Button/Button";
import { vehicleLoaderFormId } from "../VehicleMapping/VehicleLoader";
import { packageInfoEditFormId } from "./PackageInfo";

export const Footer: FunctionComponent<{
  hide: VoidFunction;
  isSending: boolean;
  modelsAreLoading: boolean;
  selectTab: (index: number) => void;
  shouldFetchVehicles: boolean;
  tabIndex: number;
  vehicleManufacturerIds: number[];
  vehicleYearIds: number[];
}> = ({
  hide,
  isSending,
  modelsAreLoading,
  selectTab,
  shouldFetchVehicles,
  tabIndex,
  vehicleManufacturerIds,
  vehicleYearIds,
}) => {
  const { t } = useTranslation();
  return (
    <footer className="new-package-dialog__footer">
      {tabIndex === 0 && (
        <>
          <Button aria-label="close" onClick={hide}>
            {t("packageEditor.close")}
          </Button>
          <PrimaryButton
            onClick={(): void => {
              selectTab(1);
            }}
            aria-label="save"
          >
            {t("packageEditor.next")}
          </PrimaryButton>
        </>
      )}
      {tabIndex === 1 &&
        (shouldFetchVehicles ? (
          <>
            <Button
              onClick={(): void => {
                selectTab(0);
              }}
              aria-label="close"
            >
              {t("packageEditor.parts")}
            </Button>
            <PrimaryButton
              disabled={
                !vehicleYearIds.length || !vehicleManufacturerIds.length
              }
              aria-label="save"
              busy={modelsAreLoading}
              form={vehicleLoaderFormId}
              type="submit"
            >
              {t("packageEditor.fetchVehicles")}
            </PrimaryButton>
          </>
        ) : (
          <>
            <Button
              onClick={(): void => {
                selectTab(0);
              }}
              aria-label="close"
            >
              {t("packageEditor.parts")}
            </Button>
            <PrimaryButton
              onClick={(): void => {
                selectTab(2);
              }}
              aria-label="save"
            >
              {t("packageEditor.next")}
            </PrimaryButton>
          </>
        ))}
      {tabIndex === 2 && (
        <>
          <Button
            onClick={(): void => {
              selectTab(1);
            }}
            aria-label="close"
          >
            {t("packageEditor.vehicles")}
          </Button>
          <PrimaryButton
            aria-label="save"
            busy={isSending}
            form={packageInfoEditFormId}
            type="submit"
          >
            {t("packageEditor.updatePackage")}
          </PrimaryButton>
        </>
      )}
    </footer>
  );
};

/**
 * @see docs/worklog/TW-910-edit-package-vehicle-selector/rfc.md
 * @see docs/worklog/TW-910-edit-package-vehicle-selector/tfc.md
 */
